import BeschwerdeConfirm from '@/views/BeschwerdeConfirm.vue';
import DashboardWrapper from './views/DashboardWrapper.vue';
import LoginView from '@/views/Login.vue';
import PasswortSetzen from '@/views/PasswortSetzen.vue';
import { createRouter, createWebHistory } from 'vue-router';
import { useStore } from './store';
import RueckfrageEdit from '@/views/RueckfrageEdit.vue';
import FallDetailWrapper from '@/views/FallDetailWrapper.vue';
import EntscheidungEdit from '@/views/EntscheidungEdit.vue';
import EntscheidungDetail from '@/views/EntscheidungDetail.vue';
import KontaktDetail from '@/views/KontaktDetail.vue';
import StatistikWrapper from '@/views/StatistikWrapper.vue';
import BerichtView from '@/views/BerichtView.vue';

import UserDetail from '@/views/UserDetail.vue';
import WerberatsentscheidungenView from '@/views/Werberatsentscheidungen.vue';
import UserView from '@/views/User.vue';
import UserNeu from '@/views/UserNeu.vue';
import KontakteView from '@/views/Kontakte.vue';
import KontaktNeu from '@/views/KontaktNeu.vue';
import StellungnahmeEdit from '@/views/StellungnahmeEdit.vue';
import FaelleWrapper from '@/views/FaelleWrapper.vue';
import Impressum from '@/views/Impressum.vue';
import Datenschutz from '@/views/Datenschutz.vue';
import StellungnahmeNeu from '@/views/StellungnahmeNeu.vue';
import StellungnahmeDetailWrapper from '@/views/StellungnahmeDetailWrapper.vue';

import { getStatement } from './requests/statements';
import Fehler from '@/views/Fehler.vue';
import BeschwerdenWrapper from '@/views/BeschwerdenWrapper.vue';
import BeschwerdeNeuPublic from '@/views/BeschwerdeNeuPublic.vue';
import BeschwerdeDetailWrapper from '@/views/BeschwerdeDetailWrapper.vue';
import { getCallback } from './requests/callbacks';
import { getComplaint, getPublicComplaint } from './requests/complaints';
import BeschwerdeNeuWrapper from '@/views/BeschwerdeNeuWrapper.vue';
import BeschwerdeNeuDone from '@/views/BeschwerdeNeuDone.vue';
import FaelleVorstandAktiv from '@/views/FaelleVorstandAktiv.vue';

const base = import.meta.env.MODE !== 'production' ? '/werberat-frontend/' : '/';

// on PROD: redirect all pages with '/werberat-frontend' to root
if (import.meta.env.MODE === 'production') {
	if (location.href.includes('https://beschwerde.werberat.at/werberat-frontend')) {
		window.location.replace('https://beschwerde.werberat.at/');
	}
}

const router = createRouter({
	history: createWebHistory(base),
	routes: [
		{ path: '/', name: 'Dashboard', component: DashboardWrapper, meta: { requiresAuth: true } },
		{ path: '/login', name: 'Login', component: LoginView, meta: { public: true } },
		{ path: '/passwort-setzen/:id', name: 'PasswortSetzen', component: PasswortSetzen, props: true, meta: { requiresToken: true } },
		{ path: '/beschwerden', name: 'Beschwerden', component: BeschwerdenWrapper, meta: { hybrid: true } },
		{ path: '/beschwerde-anlegen', name: 'BeschwerdeNeu', component: BeschwerdeNeuWrapper, meta: { hybrid: true } },
		{ path: '/formular', name: 'Formular', component: BeschwerdeNeuPublic, meta: { public: true } },
		{ path: '/beschwerde/:id', name: 'BeschwerdeDetail', component: BeschwerdeDetailWrapper, props: true, meta: { detail: true, hybrid: true } },
		{ path: '/beschwerde-bestaetigen/:id', name: 'BeschwerdeConfirm', component: BeschwerdeConfirm, props: true, meta: { requiresToken: true } },
		{ path: '/beschwerde-eingereicht', name: 'BeschwerdeNeuDone', component: BeschwerdeNeuDone, meta: { public: true } },
		{ path: '/faelle', name: 'Fälle', component: FaelleWrapper, meta: { hybrid: true } },
		{ path: '/faelle-aktiv', name: 'FälleAktiv', component: FaelleVorstandAktiv, meta: { requiresAuth: true } },
		{ path: '/fall/:id', name: 'FallDetail', component: FallDetailWrapper, props: true, meta: { detail: true, hybrid: true } },
		{ path: '/entscheidung/:id', name: 'EntscheidungDetail', component: EntscheidungDetail, props: true, meta: { detail: true, requiresAuth: true } },
		{ path: '/entscheidung-bearbeiten/:id', name: 'EntscheidungEdit', props: true, component: EntscheidungEdit, meta: { requiresAuth: true } },
		{ path: '/werberatsentscheidungen', name: 'Werberatsentscheidungen', component: WerberatsentscheidungenView, meta: { requiresAuth: true } },
		{ path: '/statistik', name: 'Statistik', component: StatistikWrapper, meta: { hybrid: true } },

		{ path: '/bericht', name: 'Bericht', component: BerichtView, meta: { requiresAuth: true } },
		{ path: '/user', name: 'User', component: UserView, meta: { requiresAuth: true } },
		{ path: '/user-anlegen', name: 'UserNeu', component: UserNeu, meta: { requiresAuth: true } },
		{ path: '/user/:id', name: 'UserDetail', component: UserDetail, props: true, meta: { detail: true, requiresAuth: true } },
		{ path: '/kontakte', name: 'Kontakte', component: KontakteView, meta: { requiresAuth: true } },
		{ path: '/kontakt-anlegen', name: 'KontaktNeu', component: KontaktNeu, meta: { requiresAuth: true } },
		{ path: '/kontakt/:id', name: 'KontaktDetail', component: KontaktDetail, props: true, meta: { detail: true, requiresAuth: true } },
		{
			path: '/stellungnahme/:id',
			name: 'StellungnahmeDetail',
			component: StellungnahmeDetailWrapper,
			props: true,
			meta: { detail: true, hybrid: true, requiresAuth: true },
		},
		{
			path: '/stellungnahme-anlegen/:caseid',
			name: 'StellungnahmeNeu',
			component: StellungnahmeNeu,
			props: true,
			meta: { detail: true, requiresAuth: true },
		},
		{ path: '/stellungnahme-bearbeiten/:id', name: 'StellungnahmeEdit', component: StellungnahmeEdit, props: true, meta: { requiresToken: true } },
		{ path: '/rueckfrage-bearbeiten/:id', name: 'RueckfrageEdit', component: RueckfrageEdit, props: true, meta: { requiresToken: true } },
		{ path: '/impressum', name: 'Impressum', component: Impressum, meta: { public: true } },
		{ path: '/datenschutz', name: 'Datenschutz', component: Datenschutz, meta: { public: true } },
		{ path: '/fehler/:errorType', name: 'Fehler', component: Fehler, props: true, meta: { public: true } },
		{ path: '/:pathMatch(.*)*', redirect: '/fehler/404' },
	],
	scrollBehavior(to, from, savedPosition) {
		setTimeout(() => {
			return savedPosition || { top: 0, behavior: 'smooth' };
		}, 300);
	},
});

router.beforeEach(async (to, from, next) => {
	const store = useStore();
	const isLoggedIn = store.state.loggedin && store.state.user !== null;

	handleMetaTags(to, isLoggedIn);

	if (to.name === 'Login') {
		if (isLoggedIn) {
			return next({ name: 'Dashboard' });
		}
		return goNext(to, from, next);
	}

	if (to.meta.requiresAuth || to.query.requires_auth) {
		if (!isLoggedIn) {
			let intendedUrl = to.fullPath;
			// remove slash from url
			if (intendedUrl !== '/' && intendedUrl.endsWith('/')) {
				intendedUrl = intendedUrl.slice(0, -1);
			}

			intendedUrl = intendedUrl.replace('?requires_auth=true', '');

			store.dispatch('setIntendedUrl', intendedUrl);
			return next({ name: 'Login' });
		} else if (to.query.requires_auth) {
			// Remove requires_auth query param
			const { requires_auth, ...query } = to.query;
			return next({ path: to.path, query, hash: to.hash });
		}

		return goNext(to, from, next);
	}

	// Hybride Routen haben Views, die entweder öffentlich oder authentifiziert sein können
	// Werden im Wrapper direkt gehandlet
	if (to.meta.hybrid) {
		return goNext(to, from, next);
	}

	if (to.meta.requiresToken) {
		//? Token kann auch "code" heißen, wenn es von der Set Password Schnittstelle kommt
		const token = to.query.token || to.query.code;
		if (!token) {
			return next({ name: 'Fehler', params: { errorType: '401' } });
		}

		try {
			const validationResult = await validateToken(to.name, to.params.id, token);
			if (!validationResult) {
				return next({ name: 'Fehler', params: { errorType: '401' } });
			}
		} catch (error) {
			console.error('Token validation error:', error);
			return next({ name: 'Fehler', params: { errorType: '401' } });
		}
	}

	// if route is /fehler/asdf redirect to /fehler/404
	if (to.name === 'Fehler') {
		let errType = to.params?.errorType;
		if (errType != '401' && errType != '404') {
			return next({ name: 'Fehler', params: { errorType: '404' } });
		}
	}

	return goNext(to, from, next);
});

/**
 * Handles regular next() functuality
 * and redirects from page-with-slash to page-without-slash
 */
const goNext = (to, from, next) => {
	if (to.path !== '/' && to.path.endsWith('/')) {
		return next({ path: to.path.slice(0, -1), query: to.query, hash: to.hash });
	} else {
		return next();
	}
};

async function validateToken(routeName, id, token) {
	switch (routeName) {
		case 'StellungnahmeEdit':
			const statementResult = await getStatement(id, token);
			return statementResult.success;
		case 'RueckfrageEdit':
			const callbackResult = await getCallback(id, token);
			return callbackResult.success;
		case 'BeschwerdeConfirm':
			const complaintResult = await getPublicComplaint(id, token);
			return complaintResult.success;
		case 'PasswortSetzen':
			return true;
		default:
			return false;
	}
}

function handleMetaTags(to, isLoggedIn) {
	const robots = document.querySelector('meta[name="robots"]');
	const desc = document.querySelector('meta[name="description"]');
	const keywords = document.querySelector('meta[name="keywords"]');

	const isInternalPage = (to.meta?.public && to.meta?.public === false) || (to.meta.hybrid && isLoggedIn) || to.meta?.requiresAuth === true;

	document.title = 'Entscheidungstool | Österreichischer Werberat';
	desc.content =
		'Das Entscheidungstool des Österreichischen Werberats. Für verantwortungsbewusstes Handeln und selbstregulierte Werbung in Österreich.';
	keywords.content = 'Österreichischer Werberat, Werberat, Werbung, Beschwerden, Beschwerdeformular, Selbstregulierung, beschweren,';

	if (isInternalPage) {
		robots.content = 'noindex, nofollow';
	} else {
		if (to.name === 'Login') {
			// LOGIN
			document.title = 'Login Entscheidungstool | Österreichischer Werberat';
		} else if (to.name === 'Formular') {
			// BESCHWERDEFORMULAR
			document.title = 'Beschwerdeformular | Österreichischer Werberat';
			desc.content =
				'Ihre direkte Beschwerdemöglichkeit im Bereich Wirtschaftswerbung. Für verantwortungsbewusstes Handeln und selbstregulierte Werbung in Österreich.';
		} else if (to.name === 'Fehler') {
			// FEHLER
			document.title = 'Kein Zugriff | Österreichischer Werberat';
		} else {
			// ALL OTHER PUBLIC PAGES
			document.title = 'Aktuelle Beschwerden und Entscheidungen | Österreichischer Werberat';
			desc.content =
				'Übersicht aller aktueller Beschwerden und Entscheidungen im Bereich Wirtschaftswerbung. Für verantwortungsbewusstes Handeln und Werben in Österreich.';
			keywords.content = 'Österreichischer Werberat, Werberat, Werbung, Beschwerden, Entscheidungen';
		}
	}
}

export default router;
